import { Box } from '@mui/material';
import { Button, Typography } from '@sweep-io/sweep-design';
import { InviteUsersInputWithList } from '../../common/invite-users/InviteUsersInputWithList';
import { useRoleManagerContext } from '../role-manager/RoleManagerContext';
import { useSweepRoleGroups } from '../../common/useSweepRoleGroups';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';

const OrgInfoTab = ({
  accountName,
  userRoleGroupId,
}: {
  accountName?: string;
  userRoleGroupId?: string;
}) => {
  const { multiAccounts } = useFeatureToggle();
  const { isAdmin } = useSweepRoleGroups();
  const { setRoleManager } = useRoleManagerContext();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      data-testid="org-info"
      sx={{ zIndex: 1 }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          margin: '0 0 16px 0',
        }}
      >
        <Typography ellipsis variant="h3">
          {multiAccounts ? 'Users' : accountName ? accountName : 'Workspace'}
        </Typography>
        {isAdmin(userRoleGroupId ?? '') && (
          <Button
            variant={multiAccounts ? 'primary' : 'system'}
            onClick={() => setRoleManager(true)}
            size="small"
          >
            Manage roles
          </Button>
        )}
      </Box>

      <InviteUsersInputWithList />
    </Box>
  );
};

export { OrgInfoTab };
